<h2 i18n>Spin the wheel to start the game</h2>

<div class="table new-round-preparation-anim"></div>
